import { FileUploadData, SelectOption } from "@pulseops/common"

export namespace CSInventoryReportDocForm {
   export interface CSInventoryReportCreatingDocInfo {
      GAOfficeCode: SelectOption | undefined
      docID: SelectOption | undefined
      CSArea: SelectOption | undefined
      uploadFiles: FileUploadData []
      errorMessage: string
      keyID: string
    }
  
    export interface CSInventoryReportDocData {
      newGADlist: Array<CSInventoryReportCreatingDocInfo>
    }
  
    export interface CSInventoryReportDocListData {
      from: Date | null
      to: Date | null
      GAOfficeCode: SelectOption | undefined
      docID: SelectOption | undefined
      CSArea: SelectOption | undefined
      isSelectedAll: boolean
      inventoryReportDocList: Array<CSInventoryReportDocDataInfo>
    }
  
    export type CSInventoryReportDocDataInfo= {
      historyID: string
      isSelectedItem: boolean
    }
}